import styled from "styled-components"

export const ProfileWrapper = styled.div`
    border-radius: 4px;
    box-shadow: 0px 4px 8px rgba(34, 24, 24, 0.2);
    .input_sex{
        width: 16px;
        height: 16px;
    }
    .date_time_input{
        width: 200px;
    }
    .btn-edit{
        height: 40px;
        padding: 0 12px;
    }
   
`
